export default {"src":"/_next/static/image/src/images/SocialMediaIcons/pinterest.fac37194193fe9f47f65fe08ddd04e3c.svg","height":20,"width":18};